import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import logo from "../../../../assets/icons/WePrice-Secondaryicon-w.png";
import useCustomLoginWithRedirect from "../../../../hooks/useCustomLoginWithRedirect";
import { useAuth0 } from "@auth0/auth0-react";

const SplashModal = ({ onClose }) => {
    const [progress, setProgress] = useState(100);
    const { isAuthenticated } = useAuth0();
    const { customLoginWithRedirect } = useCustomLoginWithRedirect();

    const handleOnClick = () => {
        if (!isAuthenticated) {
            customLoginWithRedirect({
                authorizationParams: {
                    redirect_uri: window.location.origin + "/social",
                },
                appState: {
                    toggleProfile: true,
                    event: {
                        name: "tutorial_register_click",
                        referral_code: localStorage.getItem("referral_code"),
                    },
                },
            });
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev <= 0) {
                    clearInterval(interval);
                    onClose();
                    return 0;
                }
                return prev - 2;
            });
        }, 60);

        const timeout = setTimeout(() => {
            onClose();
        }, 4500);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [onClose]);

    return (
        <div className="tw-fixed tw-inset-0 tw-bg-[#331263] tw-flex tw-flex-col tw-items-center tw-justify-center tw-z-[9999] tw-text-white tw-p-6">
            <h1 className="tw-text-2xl tw-font-bold tw-mb-4 text-center">Welcome to PriceMe!</h1>
            <img src={logo} alt="PriceMe_Logo" />
            <p className="tw-text-base tw-mb-6 text-center">The social app for real estate</p>

            <button
                className="tw-bg-[#f89c24] tw-text-black tw-rounded-full tw-px-6 tw-py-3 tw-font-semibold tw-mb-4"
                onClick={onClose}
            >
                Let’s go
            </button>
            <p className="tw-text-sm">
                Already registered?{" "}
                <span className="tw-underline" onClick={handleOnClick}>
                    Log in
                </span>
            </p>

            {/* Progress bar */}
            <motion.div
                className="tw-absolute tw-bottom-0 tw-left-0 tw-h-1 tw-bg-white"
                style={{ width: `${progress}%` }}
                transition={{ ease: "linear" }}
            />
        </div>
    );
};

export default SplashModal;
